// import { RolesSystem } from 'lib/enums/RolesSystem.enum';
import { createActionTypes } from 'lib/utils/createActionTypes';

export default class UserDucks {
	public static initialState: { [label: string]: any } = {
		id: '',
		name: '',
		lastname: '',
		username: '',
		email: '',
		token: '',
		isAdmin: false,
		lastLoginAt: new Date(),
		isLoading: true,
		paymentsReminder: true,
		avatar: null,
		isStripeStandard: false
	};

	public static duckName = 'User';
	public static actionTypes: { [label: string]: string } = createActionTypes(
		{
			setLoading: 'set_loading',
			getUser: 'get_user',
			setUser: 'set_user',
			setPaymentsReminder: 'set-payments-reminder'
		},
		UserDucks.duckName,
	);

	public static getOwnState = (state): any | any[] =>
		state[UserDucks.duckName] || UserDucks.initialState;

	public static reducer(state = UserDucks.initialState, action) {
		switch (action.type) {
			case UserDucks.actionTypes.setUser:
				return {
					...state,
					...action.payload,
				};
			case UserDucks.actionTypes.setLoading:
				return {
					...state,
					isLoading: action.payload.isLoading,
				};
			case UserDucks.actionTypes.setPaymentsReminder:
				return {
					...state,
					paymentsReminder: action.payload.paymentsReminder,
				};
			default:
				return state;
		}
	}

	/**
	 *  Actions - getters
	 */

	public static getUser(
		state,
	): {
		id: string;
		name: string;
		lastname: string;
		username: string;
		email: string;
		isAdmin: boolean;
		stripeId?: string;
		token?: string;
		avatar?: string;
		lastLoginAt: Date;
		isStripeStandard?: boolean;
	} {
		const localState = this.getOwnState(state);
		return {
			id: localState.id,
			name: localState.name,
			lastname: localState.lastname || '',
			username: localState.username || '',
			email: localState.email,
			isAdmin: localState.isAdmin,
			token: localState.token || null,
			stripeId: localState.stripeId || null,
			lastLoginAt: localState.lastLoginAt,
			avatar: localState.avatar || null,
			isStripeStandard: localState.isStripeStandard
		};
	}

	public static getToken(state): string {
		return this.getOwnState(state).token;
	}

	public static getLoading(state): string {
		return this.getOwnState(state).isLoading;
	}

	public static isAuthenticated(state): boolean {
		return this.getOwnState(state).token !== '';
	}

	public static isLoading(state) {
		return this.getOwnState(state).isLoading;
	}

	public static getPaymentsReminder(state) {
		return this.getOwnState(state).paymentsReminder;
	}
	/**
	 * Actions - setters
	 */

	/**
	 *  Used to set user instance after login is over here.
	 */
	public static setUser = (userObject: {
		id?: string;
		name?: string;
		email?: string;
		lastname?: string;
		username?: string;
		token?: string;
		lastLoginAt?: Date;
		isAdmin?: boolean;
		stripeId?: string;
		isStripeStandard?: boolean;
		avatar?: string;
	}) => dispatch => {
		dispatch({
			type: UserDucks.actionTypes.setUser,
			payload: {
				...userObject,
			},
		});
	};

	/**
	 * Used to set isLoading state. e.g.: when you are logging in user.
	 */
	public static setLoading = (isLoading) => dispatch => {
		dispatch({
			type: UserDucks.actionTypes.setLoading,
			payload: {
				isLoading,
			},
		});
	};

	public static setPaymentsReminder = (paymentsReminder) => dispatch => {
		dispatch({
			type: UserDucks.actionTypes.setLoading,
			payload: {
				paymentsReminder,
			},
		});
	};
	
}



// WEBPACK FOOTER //
// ./src/stores/ducks/User.duck.ts